import React from 'react';

import StarsInfo from '@swf/components/StarsInfo/StarsInfo';
import Translation from '@swf/components/Translation/Translation';

import { TXTWCL_An_unexpected_error_occurred_w_ELL_1 } from './ErrorMessage.messages.json';

const ErrorMessage: React.FC = () => (
  <StarsInfo type="error">
    <Translation {...TXTWCL_An_unexpected_error_occurred_w_ELL_1} />
  </StarsInfo>
);

export default ErrorMessage;
